import * as React from "react";
import * as Globalize from "globalize";
import * as Immutable from "immutable";
import Dialog from "components/dialog";
import Button from "components/form/button";
import theme from "styles/theme";
import { toDataTest } from "helpers/test";

// activeFiltersValues, onChange, field
interface Ifiltervalue {
    __key: string;
    __data: string[];
}

interface IShared {
    filter: Ifiltervalue;
    activeFiltersValues: Immutable.Map<string, any>;
    isModalOpen: boolean;
    onChange: (e: any, field?: string, value?: string) => void;
}

interface IProps extends IShared {
    key: any;
    closeModal: () => void;
}

interface IHTMLButtonElement extends React.HTMLProps<HTMLButtonElement> {
    filtervalue: string;
    getAttribute?: (attribute: string) => string;
}

interface IModalState {
    localFilters: Immutable.Map<string, any>;
}

class CustomImageModal extends React.Component<IProps, IModalState, any> {
    styles = {
        bodyStyle: {
            minHeight: "500px",
        },
        contentStyle: {
            maxWidth: "780px",
        },
        filterImage: {
            width: "173px",
            height: "272px",
            position: "relative" as "relative",
            bottom: "22px",
        },
        filter: {
            display: "inline-block",
            fontSize: "14px",
            margin: "5px",
            verticalAlign: "top",
            color: "inherit",
            height: "232px",
            width: "173px",
            borderRadius: "0px",
            boxShadow: "none",
        },
        selectedFilter: {
            display: "inline-block",
            fontSize: "14px",
            margin: "5px",
            verticalAlign: "top",
            color: "inherit",
            height: "232px",
            width: "173px",
            borderRadius: "0px",
            boxShadow: `0px 0px 0px 2px ${theme.palette.accent1Color}`,
        },
        modalButton: {
            marginRight: "25px",
        },
        actionsContainerStyle: {
            borderTop: "0px ",
        },
    };

    constructor(props) {
        super(props);

        const imageFilterValues = this.props.activeFiltersValues.get(this.props.filter.__key);
        this.state = {
            localFilters: Immutable.Map({ [this.props.filter.__key]: imageFilterValues }),
        };
    }

    handleSetFilter = (event: React.MouseEvent<IHTMLButtonElement>) => {
        event.stopPropagation();
        const { filter } = this.props;
        let { localFilters } = this.state;

        const filterKey = filter.__key;
        const value = event.currentTarget.getAttribute("data-filtervalue");
        let filterList = localFilters.get(filterKey) || Immutable.List();
        const selectedIndex = filterList.findIndex((elem) => elem === value);

        if (selectedIndex > -1) {
            filterList = filterList.delete(selectedIndex);
        } else {
            filterList = filterList.push(value);
        }
        localFilters = localFilters.set(filterKey, filterList);
        this.setState({ localFilters });
    };

    handleApplyFilter = () => {
        const { closeModal, onChange, activeFiltersValues, filter } = this.props;
        const { localFilters } = this.state;
        const imageFilterValues = localFilters.get(filter.__key);
        const updatedFilters = activeFiltersValues.set(filter.__key, imageFilterValues);

        onChange(updatedFilters);

        closeModal();
    };

    handleCloseModal = () => {
        const { closeModal, activeFiltersValues, filter } = this.props;
        const imageFilterValues =
            activeFiltersValues.get(filter.__key) || Immutable.Map({ [filter.__key]: Immutable.List() });
        this.setState({ localFilters: imageFilterValues });
        closeModal();
    };

    render() {
        const { filter, isModalOpen } = this.props;
        const { localFilters } = this.state;
        const filterKey = filter.__key;
        const filterArray = localFilters.get(filterKey) || Immutable.List();

        const actions = [
            <Button
                key="cancel"
                type="submit"
                style={this.styles.modalButton}
                label={Globalize.formatMessage("Cancel")}
                onClick={this.handleCloseModal}
            />,
            <Button
                key="apply"
                type="submit"
                style={this.styles.modalButton}
                primary={true}
                label={Globalize.formatMessage("Apply")}
                onClick={this.handleApplyFilter}
            />,
        ];

        const listItems = filter.__data.map((item, i) => {
            const selectedIndex = filterArray.findIndex((elem) => elem === item);

            return (
                <Button
                    key={"card-" + i}
                    style={selectedIndex > -1 ? this.styles.selectedFilter : this.styles.filter}
                    data-filtervalue={item}
                    data-test={`${toDataTest(filter.__key)}-condition-option`}
                    onClick={this.handleSetFilter}
                    disableTouchRipple={true}
                >
                    <img alt={item} src={item.replace("T.jpg", "G.jpg")} style={this.styles.filterImage} />
                </Button>
            );
        });

        return (
            <Dialog
                title={Globalize.formatMessage("Filter By Custom Image")}
                open={isModalOpen}
                onRequestClose={this.handleCloseModal}
                autoScrollBodyContent={true}
                modal={true}
                actions={actions}
                bodyStyle={this.styles.bodyStyle}
                contentStyle={this.styles.contentStyle}
                actionsContainerStyle={this.styles.actionsContainerStyle}
                key={filterArray}
            >
                {listItems}
            </Dialog>
        );
    }
}

export default CustomImageModal;
